import { Controller } from 'stimulus';

// The task page's Schedule strip (jobs/tasks/show/_schedule_strip): after a
// save from one of its windows (tasks:changed, from tasks-popup-editor), it
// draws itself again from data-task-strip-url, as the Tasks tab's row does.
export default class extends Controller {
  connect() {
    this.changed = (e) => {
      if (e.detail && String(e.detail.taskId) === this.data.get('task')) this.refresh();
    };
    document.addEventListener('tasks:changed', this.changed);
  }

  disconnect() {
    document.removeEventListener('tasks:changed', this.changed);
  }

  refresh() {
    fetch(this.data.get('url'), { credentials: 'same-origin', headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' } })
      .then((r) => (r.ok && !r.redirected ? r.text() : ''))
      .then((html) => {
        if (html.indexOf('task-schedule-strip') < 0 || !this.element.parentNode) return;
        const holder = document.createElement('div');
        holder.innerHTML = html.trim();
        if (holder.firstElementChild) this.element.replaceWith(holder.firstElementChild);
      })
      .catch(() => {});
  }
}
